import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import SwiperCore from "swiper";
import { Autoplay, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "./MedicaxTestimonials.css";

const testimonials = [
  {
    name: "Ramesh K.",
    text: "JEEVANDAAN Hospital provided excellent care and support during my treatment. The doctors were highly experienced and very caring."
  },
  {
    name: "Sunita S.",
    text: "From admission to discharge, the staff was polite, professional, and attentive. I truly felt safe and well cared for."
  },
  {
    name: "Amit P.",
    text: "The doctors explained everything clearly and patiently. The treatment was accurate and effective."
  },
  {
    name: "Neha G.",
    text: "Clean facilities, modern equipment, and compassionate staff — JEEVANDAAN Hospital truly puts patients first."
  },
  {
    name: "Vikram R.",
    text: "Emergency services were fast and well-managed. Thanks to the entire team for their quick response."
  },
  {
    name: "Priya M.",
    text: "I am very satisfied with the consultation and treatment. The doctors listen carefully and provide the best guidance."
  },
  {
    name: "Sanjay T.",
    text: "JEEVANDAAN Hospital combines advanced medical care with a human touch. Highly recommended."
  },
  {
    name: "Anjali D.",
    text: "The nursing staff was extremely supportive and caring throughout my recovery."
  },
  {
    name: "Rahul V.",
    text: "Affordable treatment with excellent medical facilities. One of the best hospitals in the city."
  },
  {
    name: "Meena C.",
    text: "A hospital you can truly trust. Professional doctors, helpful staff, and a comforting environment."
  }
];
SwiperCore.use([Autoplay, Navigation]);
export default function MedicaxTestimonials() {
  return (
    <div
      className="testimonial4-section-area sp1"
      style={{
        backgroundImage: "url(assets/img/all-images/bg/BG-Orange-shade.png)",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-8 m-auto">
            <div className="heading4 text-center space-margin60">
              <h5 className="vl-section-subtitle">
                JEEVANDAAN Hospital<span>|</span> Patient Testimonials
              </h5>
              <h2 className="vl-section-title">
                Our patients always trust us
              </h2>
            </div>
          </div>
        </div>
      </div>
      

      <div className="row">
        <div className="col-lg-12">
          <Swiper
            spaceBetween={20}
            loop
            navigation
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            breakpoints={{
              0: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
            }}
          >
            {testimonials.map((item, index) => (
              <SwiperSlide key={index}>
                <Testimonial name={item.name} text={item.text} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
}

function Testimonial({ name, text }) {
  return (
    <div className="mc-testimonial-card">
      <span className="mc-quote">❝</span>
      <p className="mc-review">{text}</p>
      <div className="mc-client">
        <h4>{name}</h4>
        <div className="mc-stars">★★★★★ <span>(4.8)</span></div>
      </div>
    </div>
  );
}
